import { useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Close, Facebook, Instagram, Link, Messenger, Telegram, Whatsapp } from '../assert/icon';
import { camera, renderer, scene, updateProduct } from '../js/webGL';
import { showToast } from '../redux-tool/slice/toastSlice';
import { setIsShowMenu, setIsShowMenuToolbar, setIsShowProduct } from '../redux-tool/slice/uiSlice';
import './styles/Sharing.css';

const LOGO_SHARE_LIST = [
  { name: 'Telegram', value: Telegram },
  { name: 'Messenger', value: Messenger },
  { name: 'Whatsapp', value: Whatsapp },
  { name: 'Instagram', value: Instagram },
  { name: 'Facebook', value: Facebook },
];

export function Sharing({ queryInfo, productInfo }) {
  const { TOKEN } = queryInfo;
  const { cart_item_id, order_item_id } = productInfo;
  const urlShare = `${window.location.origin}/?decal=true&token=${TOKEN}${
    cart_item_id ? `&cart_item_id=${cart_item_id}` : `&order_item_id=${order_item_id}`
  }`;

  const dispatch = useDispatch();
  const [id] = useState(Date.now());
  const [isFinished, setIsFinished] = useState(false);
  const [isNavigatorShare, setIsNavigatorShare] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [image, setImage] = useState('');
  const isMobile = useMediaQuery('(max-width:600px)');

  const onFinished = () => {
    dispatch(setIsShowMenu(false));
    dispatch(setIsShowMenuToolbar(false));
    dispatch(setIsShowProduct(true));
  };

  const onFinishedLink = (linkUrl) => {
    setIsFinished(true);
    onFinished();
  };

  const createSharedLink = () => {
    updateProduct();
    const linkUrl = `${window.location.origin}?decal=${id}`;
    setTimeout(() => onFinishedLink(linkUrl), 1000);
  };

  const handleShareClick = () => {
    setIsShow(true);
    renderer.render(scene, camera);
    setImage(renderer.domElement.toDataURL('image/png'));
  };

  useEffect(() => {
    createSharedLink();
    if (navigator.share) {
      setIsNavigatorShare(true);
    }
  }, []);

  return !isFinished ? (
    <div className="bgwaiting show">
      <img src="/theme/img/bgWaiting.png" alt="iconLogo" />
    </div>
  ) : (
    <div>
      <div className="submitComplete" style={{ textAlign: 'center', margin: '0 auto' }}>
        <p className="sharing-submit">Submit Complete!</p>
        <p className="sharing-subtitle">
          Your custom clothing has been <br /> submitted successfully!
        </p>
        <div className="btnShare" onClick={handleShareClick}>
          <div className="btnShare_content">
            <img src="/theme/img/iconShare.svg" alt="iconLogo" style={{ marginRight: '8px' }}></img>
            Share your design
          </div>
        </div>
      </div>

      <div className={`bottom-sheet ${isShow ? 'show' : ''}`}>
        <div className="sharing-header">
          <h6 className="sharing-title">Share your design</h6>
          <img
            className="sharing-header-close"
            onClick={() => setIsShow(false)}
            src={Close}
            alt="close-icon"
            width={28}
            height={28}
          />
        </div>
        <div className="sharing-content">
          {image ? (
            <div className="sharing-img-wrapper">
              <img src="/theme/img/bg_share.png" width={149} height={257} alt="shareImg" />
              <img
                className="sharing-img"
                src={image}
                alt="shareImg"
                style={{ width: isMobile ? '150%' : '200%' }}
              />
            </div>
          ) : (
            <img src="/theme/img/shareImg.png" width={149} height={257} alt="shareImg" />
          )}
          {isNavigatorShare ? (
            <div className="sharing-share-to">
              <span>Share to:</span>
              <div className="sharing-share-to-logo">
                {LOGO_SHARE_LIST.map((item) => (
                  <img
                    key={item.name}
                    src={item.value}
                    alt={item.name}
                    width={40}
                    height={40}
                    onClick={() => {
                      if (navigator.share) {
                        navigator
                          .share({
                            title: 'Share',
                            text: urlShare,
                          })
                          .then(() => console.log('Chia sẻ thành công'))
                          .catch((error) => console.error('Lỗi khi chia sẻ:', error));
                      } else {
                        console.log('Trình duyệt không hỗ trợ Web Share API');
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          ) : (
            <></>
          )}
          <button
            className="sharing-btn"
            onClick={() => {
              navigator.clipboard
                .writeText(urlShare)
                .then(() => {
                  dispatch(
                    showToast({
                      message: 'Copied successfully.',
                    }),
                  );
                })
                .catch((err) => {
                  console.error('Lỗi khi copy:', err);
                  dispatch(
                    showToast({
                      message: 'Failed to copy. Please try again.',
                      type: 'error',
                    }),
                  );
                });
            }}
          >
            <span>Copy link</span>
            <img src={Link} alt="link" />
          </button>
        </div>
      </div>
    </div>
  );
}
